(function () {
  function initHoverReveal(sectionEl) {
    if (!sectionEl) return;
    if (window.innerWidth < 768) return;

    const grid = sectionEl.querySelector('.how-it-works__grid');
    if (!grid) return;

    grid.querySelectorAll('.how-it-works__item').forEach(function (item) {
      // Skip items where text is always visible — no hover reveal needed
      if (item.classList.contains('how-it-works__item--always-visible')) return;

      const imgWrap = item.querySelector('.how-it-works__img-wrap');
      const textEl = item.querySelector('.how-it-works__text');
      if (!imgWrap || !textEl) return;

      // Reset any previously set inline styles so measurements are fresh
      imgWrap.style.height = '';
      item.style.height = '';

      // aspect-ratio drives the height — measure it so we can animate with px
      const imgH = imgWrap.offsetHeight;
      const textH = textEl.offsetHeight;

      // Lock to explicit px so CSS transition can animate height
      imgWrap.style.height = imgH + 'px';

      // Lock item to image height only — text is clipped below by overflow:hidden
      item.style.height = imgH + 'px';

      item.addEventListener('mouseenter', function () {
        imgWrap.style.height = (imgH - textH) + 'px';
      });
      item.addEventListener('mouseleave', function () {
        imgWrap.style.height = imgH + 'px';
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.how-it-works-section').forEach(initHoverReveal);
  }

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  });

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.how-it-works-section');
    if (section) initHoverReveal(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
